import React from 'react';

/**
 * App background. Flat, neutral, theme-aware (no remote image).
 * Kept the original name/API (children passthrough) for backward compatibility.
 */
const VenetianBackground = ({ children }) => {
  return (
    <div className="fixed inset-0 -z-10 bg-background">
      {/* Very subtle dot grid for depth — barely visible, pure CSS */}
      <div
        className="absolute inset-0 opacity-[0.4] dark:opacity-[0.25]"
        style={{
          backgroundImage:
            'radial-gradient(circle, rgb(var(--border)) 1px, transparent 1px)',
          backgroundSize: '22px 22px',
        }}
      />
      {children}
    </div>
  );
};

export default VenetianBackground;
